export function fetchCart() {
  return fetch('/cart.js', {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then((res) => res.json());
}

interface Item {
  id: number;
  quantity: number;
  selling_plan?: number;
  properties?: Object;
}

export function addItemById(formData: { items: Item[] } | Item) {
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(formData),
  })
    .then((r) => r.json())
    .then((response) => {
      if (response.status === 422) {
        // eslint-disable-next-line no-alert
        alert(response.description);
      }
      return fetchCart();
    });
}
